import mixins from 'vue-typed-mixins';

import PlbscfMixin from '@/entries/user/mixins/PlbscfMixin';
import 事業所Mixin from '@/entries/user/mixins/事業所Mixin';
import 勘定科目UpdateOrderCheckerMixin from '@/entries/user/mixins/勘定科目UpdateOrderCheckerMixin';

import Abstract計画PlbscfService from '@/classes/service/Abstract計画PlbscfService';

export default mixins(PlbscfMixin, 事業所Mixin, 勘定科目UpdateOrderCheckerMixin).extend({
  name: 'M計画PlbscfMonitoringMixin',

  methods: {
    async loadAndParse<T>(service: Abstract計画PlbscfService<T>): Promise<T> {
      // 勘定科目 / 部門 / データ一覧 取得
      const 勘定科目Request = this.api.k.list勘定科目(this.事業所.pk, undefined, undefined, undefined, {
        params: { sj: 'PLBSCF_計画' },
      });
      const 部門Request = this.api.b.list部門(this.事業所.pk);
      const データRequest = this.api.d.listデータ(this.計画書.pk, service.getRelationalE入力分類s(), undefined, {
        params: { sj: 'PLBSCF' },
      });
      // API呼び出し
      const responses = await Promise.all([勘定科目Request, 部門Request, データRequest]);
      service.set勘定科目s = responses[0].data;
      service.set部門s = responses[1].data;
      this.initializeFlag();
      this.setPksCannotUpdateOrder(responses[0].data);
      return service.parse(responses[2].data);
    },
  },
});
